import React, { useState, useEffect } from 'react';
import { Info } from 'lucide-react';
import { useHistory, useParams } from "react-router-dom";
import Tooltip from './Tooltip';
import useFetch from '../../hooks/useFetch';
import apiHelper from '../../apiHelper';
export default function EditEntities() {


    const { data, loading, error, fetchData } = useFetch();
    const [validationError, setValidationError] = useState();
    const [successMessage, setSuccessMessage] = useState('');
    const [disabled, setDisabled] = useState(false);
    const [entities, setEntities] = useState([]);

    const [formData, setFormData] = useState({
        entity_name: '',
        entity_short_name: '',
        status: '1',
        uen: '',
        note: '',
        parent_id: '',
    });

    const [errors, setFormErrors] = useState({
        entity_name: '',
        entity_short_name: ''
    });

    let { id } = useParams();

    useEffect(() => {

        async function fetchData() {
            const response = await apiHelper('entities/list/');
            if (response && response.ok) {
                const result = await response.json();
                const data = result.filter(item => item.entity_id != id);
                setEntities(data);
            }

        }

        async function fetchEntity() {
            const response = await apiHelper(`entities/show/${id}/`, 'GET');
            if (response && response.ok) {
                const result = await response.json();
                setFormData({
                    entity_name: result.entity_name,
                    entity_short_name: result.entity_short_name,
                    status: result.status,
                    uen: result.uen,
                    note: result.note,
                    parent_id: result.parent_id
                });
            }
        }

        fetchEntity();
        fetchData();

    }, []); // Empty dependency array ensures the effect runs only once


    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const history = useHistory();

    const handleSave = async () => {

        setDisabled(true);
        let form_errors = { entity_name: '', uen: '' };
        let is_error = false;
        if (!formData.entity_name) {
            form_errors["entity_name"] = "This field is required!";
            is_error = true;
        }
        if (!formData.entity_short_name) {
            form_errors["entity_short_name"] = "This field is required!";
            is_error = true;
        }
        setFormErrors(form_errors);

        if (is_error) {
            setDisabled(false);
            return false;
        }

        const response = await apiHelper(`entities/update/${id}/`, 'POST', formData);
        setDisabled(false);

        if (response) {
            if (response.ok) {
                setSuccessMessage("Entity is updated successfully.");
                setValidationError([]);
            }
            else if (response.status == 400) { //for validation error
                const response_errors = await response.json();
                let errors = [];
                for (let i in response_errors) {
                    errors.push(`${i}: ${response_errors[i][0]}`);
                }
                setValidationError(errors);
                setSuccessMessage('');
            }
        }

    };

    const handleDiscard = () => {
        history.goBack();
    };

    const [activeTab, setActiveTab] = useState("Edit Entitie");

    const breadcrumbs = [
        "Organisations",
        "Company",
        "Entities",
        activeTab
    ];

    return (
        <>
            <div className="company-body main-company-body-inner">
                <div className="breadcrumb">
                    {breadcrumbs.map((crumb, index) => {
                        const isLast = index === breadcrumbs.length - 1;
                        return (
                            <span
                                key={index}
                                className={`breadcrumb-item ${crumb === "Entities" ? "clickable" : ""}`}
                                onClick={() => {
                                    if (crumb === "Entities") {
                                        history.push("/company", { tab: "entities" });
                                    }
                                }}
                                style={{ cursor: crumb === "Entities" ? "pointer" : "default" }}
                            >
                                {crumb}
                                {!isLast ? "  " : ""}
                            </span>
                        );
                    })}
                </div>

                {successMessage && (
                    <div
                        className="d-flex align-items-center justify-content-between"
                        role="alert"
                        style={{
                            boxShadow: "0px 4px 10px 0px #0000001F",
                            padding: "15px 10px",
                            borderRadius: "12px",
                            border: "1px solid #198754",   // green border
                            backgroundColor: "#D1E7DD",    // light green background
                            color: "#0F5132",              // dark green text
                            fontSize: "12px",
                            position: "fixed",
                            top: "10px",
                            width: "calc(100% - 20px)",
                            maxWidth: "640px",
                            left: "50%",
                            transform: "translateX(-50%)",
                            zIndex: 2000,
                        }}
                    >
                        <div className="d-flex align-items-center" style={{ gap: "6px" }}>
                            <strong>{successMessage}</strong>
                        </div>

                        <span
                            style={{ cursor: "pointer", fontWeight: "bold" }}
                            onClick={() => setSuccessMessage("")}
                        >
                            ✕
                        </span>
                    </div>
                )}


                <div className='edit-organisation-info'>
                    <div className='edit-organisation-left'>
                        <h1>Edit Entity</h1>
                    </div>
                    <div className='discard-save-organisation-right d-flex align-items-center gap-2'>
                        <button className="dark-button" type='button' onClick={handleDiscard}>Discard</button>
                        <button className="dark-border" type='button' onClick={handleSave} disabled={disabled}>Save</button>
                    </div>
                </div>

                <div className="info-section">
                    <div className="info-card new-info-overflow-auto">
                        <div className="info-header">
                            <h4 className="info-title">Entity Info</h4>
                        </div>

                        {loading && <p>Loading...</p>}

                        <div className="info-content d-block">
                            <div className='grid-info-adding'>

                                {successMessage && <div style={{ color: 'green' }} className="success-message">{successMessage}</div>}

                                <ul style={{ color: 'red' }}>
                                    {validationError && validationError.map((error, index) => (
                                        <li key={index}>{error}</li>
                                    ))}
                                </ul>

                                <div className='row gappingcls-added'>
                                    <div className='col-lg-6 col-md-6 col-12'>
                                        <div className="info-inner">
                                            <label htmlFor="entityname" className="form-label">
                                                Entity Name <span className='error-color'>*</span>
                                            </label>
                                            <input type="text" className="form-control common-input-all" name="entity_name" value={formData.entity_name} onChange={handleChange} id="entityname" placeholder="Entity Name" />
                                            {errors.entity_name && <p style={{ color: 'red' }}>{errors.entity_name}</p>}
                                        </div>
                                    </div>
                                    <div className='col-lg-6 col-md-6 col-12'>
                                        <div className="info-inner">
                                            <label htmlFor="status" className="form-label">
                                                Status <span className='error-color'>*</span>
                                            </label>
                                            <div className='flexing-type-radio'>
                                                <div className="form-check">
                                                    <input className="form-check-input" type="radio" value="1" checked={formData.status == '1'} name="status" onChange={handleChange} id="flexRadioDefault1" />
                                                    <label className="form-check-label" htmlFor="flexRadioDefault1">
                                                        Active
                                                    </label>
                                                </div>
                                                <div className="form-check">
                                                    <input className="form-check-input" type="radio" value="0" checked={formData.status == '0'} name="status" onChange={handleChange} id="flexRadioDefault2" />
                                                    <label className="form-check-label" htmlFor="flexRadioDefault2">
                                                        Inactive
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className='row gappingcls-added'>
                                    <div className='col-lg-6 col-md-6 col-12'>
                                        <div className="info-inner">
                                            <label htmlFor="shortName" className="form-label d-flex align-items-center gap-2">
                                                Short Name
                                                <Tooltip content="A shorter, human-friendly label for your entity">
                                                    <Info size={16} className="info-icon" />
                                                </Tooltip>
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control common-input-all"
                                                id="shortName"
                                                name="entity_short_name"
                                                placeholder="Entity Short Name"
                                                onChange={handleChange}
                                                value={formData.entity_short_name}
                                            />
                                            {errors.entity_short_name && <p style={{ color: 'red' }}>{errors.entity_short_name}</p>}
                                        </div>
                                    </div>
                                    <div className='col-lg-6 col-md-6 col-12'>
                                        <div className="info-inner">
                                            <label htmlFor="uen" className="form-label d-flex align-items-center gap-1">
                                                UEN <span className='error-color'>*</span>
                                                <Tooltip content="Human-friendly label for your entity">
                                                    <Info size={16} className="info-icon" />
                                                </Tooltip>
                                            </label>
                                            <select name="uen" value={formData.uen} onChange={handleChange} className="form-select new-form-select-cls" aria-label="Default select example">
                                                <option defaultValue>Select Parent Department</option>
                                                <option>Select Department One</option>
                                                <option>Select Department Two</option>
                                                <option>Select Department Three</option>
                                            </select>
                                            {errors.uen && <p style={{ color: 'red' }}>{errors.uen}</p>}
                                        </div>
                                    </div>
                                </div>

                                <div className='row gappingcls-added'>
                                    <div className='col-lg-6 col-md-6 col-12'>
                                        <div className="info-inner">
                                            <label htmlFor="parentEntity" className="form-label d-flex align-items-center gap-1">
                                                Parent Entity
                                                <Tooltip content="Friendly label for your entity">
                                                    <Info size={16} className="info-icon" />
                                                </Tooltip>
                                            </label>
                                            <select name="parent_id" value={formData.parent_id} onChange={handleChange} className="form-select new-form-select-cls" aria-label="Default select example">
                                                <option defaultValue>Select Parent Entity</option>

                                                {entities && entities.map((item, index) => (
                                                    <option key={index} value={item.entity_id}>{item.entity_name}</option>
                                                ))}

                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="info-card">
                        <div className="info-header">
                            <h4 className="info-title">Additional Info</h4>
                        </div>
                        <div className="info-content">
                            <div className="info-inner common-textarea">
                                <label htmlFor="exampleFormControlTextarea1" className="form-label">Note</label>
                                <textarea name="note" value={formData.note} onChange={handleChange} className="form-control w-100 common-textarea-all" id="exampleFormControlTextarea1" rows="3"></textarea>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
